/* istanbul ignore file */

import { getPadraoComRetorno } from 'services/api';
import { removeTodasMascaras } from 'utils/stringFormatter';

export const fetchObterEnderecoPorCep = cep => dispatch => {
  return new Promise((resolve, reject) => {
    const cepFormatado = removeTodasMascaras(cep);
    const url = `Endereco/ObterEnderecoPorCep/${cepFormatado}`;

    dispatch(getPadraoComRetorno(url))
      .then(res => resolve(res))
      .catch(erro => reject(erro));
  });
};
